import {useCallback} from "react";
import languageObject from "translations";

export const useTranslation = () => {
    return useCallback((id: string, parameters?: Record<string, string | number>) => {
        return languageObject.translate(id, parameters);
    }, []);
}